<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-auto d-none d-md-flex flex-column px-0 h-100 overflow-y-auto overflow-x-hidden">
      <ng-content select=".tabs"></ng-content>
      <div class="px-2 py-4 border-end filters flex-grow-1" [style.width.rem]="17">
        <ng-container *ngTemplateOutlet="filtersRef"></ng-container>
      </div>
    </div>
    <div class="col mh-100 d-flex flex-column align-items-stretch">
      <div class="row bg-light px-2 py-2 border-bottom" [style.height.px]="57">
        @if (allSelectable()) {
          <div class="col-auto d-none d-md-flex">
            <app-selection-checkbox class="d-flex align-items-center" [ngModel]="selectionState()"
                                    (ngModelChange)="selectionStateChange.emit($event)"></app-selection-checkbox>
          </div>
        }
        <div class="col-auto d-flex d-md-none">
          <ng-content select=".tabs-mobile"></ng-content>
        </div>
        <div class="col-auto d-flex d-md-none px-1">
          <button class="btn text-primary p-0 btn-close-wrapper rounded-circle" (click)="openFiltersInModal()"
                  [style.width.px]="42" [ngClass]="facetUtils.hasActiveFilters(overviewFilters()) ? 'active': ''">
            <span class="fa-light fa-filter fa-fw m-0 h4"></span>
          </button>
        </div>
        <div class="col-auto d-flex d-md-none px-1">
          <button onPopover class="btn text-primary p-0 btn-close-wrapper rounded-circle"
                  [style.width.px]="42" [ngClass]="overviewFilters().term ? 'active': ''"
                  data-bs-toggle="popover" [popoverContent]="termPopover" [placement]="'bottom'"
                  popoverClass="pop-container-small position-fixed">
            <span class="fa-light fa-search fa-fw m-0 h4"></span>
          </button>
        </div>
        <div class="col col-xl-6 d-none d-md-flex align-items-center" style="max-width: 320px;">
          <app-filter [ngModel]="overviewFilters().term" [minCharacters]="3" [debounceTime]="300"
                      (ngModelChange)="from = 0; endReached = false;"
                      [searchFunction]="searchFunction()" (resultsFound)="resultsFound.emit($event)"
                      placeholder="Search"></app-filter>
        </div>
        <ng-content select=".center-bar"></ng-content>
        <div class="col-auto ms-auto d-flex flex-row align-items-center">
          <ng-content select=".header-bar"></ng-content>
        </div>
      </div>
      <div class="row flex-grow-1" style="height: 0">
        @if (isEmpty()) {
          <div class="w-100 h-100">
            <ng-content select=".empty-container"></ng-content>
          </div>
        } @else {
          @if (virtualScroll()) {
            <cdk-virtual-scroll-viewport [itemSize]="itemSize()" class="col-12 px-0 mh-100"
                                         (scrolledIndexChange)="onVirtualScroll($event)">
              <div *cdkVirtualFor="let item of virtualData(); trackBy: virtualTrackBy()" class="virtual-item">
                <ng-container *ngTemplateOutlet="virtualItemTemplate(); context: { $implicit: item }"></ng-container>
              </div>
            </cdk-virtual-scroll-viewport>
          } @else {
            <app-scroller (endReached)="loadNextPage.emit()" class="col-12 px-0 mh-100">
              <ng-content select=".overview-items"></ng-content>
            </app-scroller>
          }
        }
      </div>
      <ng-content select=".overview-footer"></ng-content>
    </div>
  </div>
</div>

<div id="filtersModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="custom-modal-content">
      <ng-content select=".modal-content"></ng-content>
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Remove item</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngTemplateOutlet="filtersRef"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #termPopover>
  <div class="row">
    <div class="col-12">
      <app-filter [ngModel]="overviewFilters().term" [minCharacters]="3" [debounceTime]="300"
                  (ngModelChange)="from = 0; endReached = false;"
                  [searchFunction]="searchFunction()" (resultsFound)="resultsFound.emit($event)"
                  placeholder="Search"></app-filter>
    </div>
  </div>
</ng-template>

<ng-template #filtersInModal>
  <div class="modal-content">
    <div class="modal-body">
      <ng-container *ngTemplateOutlet="filtersRef"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #filtersRef>
  <div>
    @if (!!quickViews()) {
      <label class="mx-3 sub-text text-uppercase d-inline-flex">Quick views</label>
      <div class="btn-close-wrapper d-md-none rounded-circle position-absolute end-0 me-2" style="top: -8px">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="row-md g-0 d-flex flex-column mb-4 mt-2">
        @for (quickView of quickViews(); track quickView.code) {
          @if (!quickView.hidden || !quickView.hidden()) {
            <button class="col-md-12 h2 btn btn-bg-secondary text-start d-inline-flex align-items-center" type="button"
                    [ngClass]="{'active': overviewFilters().selectedQuickView.code === quickView.code}"
                    (click)="changeQuickView(quickView)"
                    style="height: 56px; min-width: 15rem;">
              <i class="fa-light fa-fw me-3 h4 mb-0" [ngClass]="quickView.icon" [style.width.px]="30"></i>
              {{ quickView.name }}
            </button>
          }
        }
      </div>
    }
    @if (facets()) {
      <app-facets-overview [facets]="facets()" [otherFacets]="otherFacets()" [overviewFilters]="overviewFilters()"
                           [specificFacetFiltersTemplate]="specificFacetFiltersTemplate()"
                           [facetNameFormatter]="facetNameFormatter()" (filtersCleared)="filtersCleared.emit($event)"
                           (facetFiltersChanged)="onFacetValuesChange($event)"></app-facets-overview>
    }
    @if (facetsLoading()) {
      <div class="w-100 h-100 d-flex align-items-center justify-content-center">
        <app-loading-icon [loading]="true" [size]="40"></app-loading-icon>
      </div>
    }
  </div>
</ng-template>
